export default __webpack_public_path__ + "static/media/element_65.6a155ad1.avif";